import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAuth } from "../auth/AuthProvider";

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import CssBaseline from '@mui/material/CssBaseline';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import MuiCard from '@mui/material/Card';
import { styled } from '@mui/material/styles';
import AppTheme from '../../Shared-Theme/AppTheme';
import "./Login.css";

const Card = styled(MuiCard)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'center',
  width: '100%',
  padding: theme.spacing(4),
  gap: theme.spacing(2),
  margin: 'auto',
  [theme.breakpoints.up('sm')]: {
    maxWidth: '450px',
  },
  borderRadius: '20px',
  boxShadow:
    'rgba(9, 11, 17, 0.05) 0px 5px 15px, rgba(19, 23, 32, 0.08) 0px 15px 30px -5px',
}));

const SignInContainer = styled(Stack)(({ theme }) => ({
  height: '100vh',
  padding: theme.spacing(4),
  color: "#121212",
  backgroundColor: "#fff",
  border: "1px solid rgba(255, 255, 255, 0.12)",
  boxShadow: "rgba(9, 11, 17, 0.05) 0px 5px 15px, rgba(19, 23, 32, 0.08) 0px 15px 30px -5px",  
  justifyContent: 'center',
  '&::before': {
    content: '""',
    display: 'block',
    position: 'absolute',
    zIndex: -1,
    inset: 0,
    backgroundImage:
      'radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))',
    backgroundRepeat: 'no-repeat',
  },
}));

export default function Login() {
  const [userName, setUserName] = useState('');
  const [pass, setPass] = useState('');
  const { login, userToken } = useAuth();
  const navigate = useNavigate();

  // FIX: Add these states
  const [usernameError, setUsernameError] = useState(false);
  const [usernameErrorMessage, setUsernameErrorMessage] = useState('');
  const [passwordError, setPasswordError] = useState(false);
  const [passwordErrorMessage, setPasswordErrorMessage] = useState('');

  useEffect(() => {
    if (userToken) navigate('/admin');
  }, [userToken]);

  async function loginUser(e) {
    e.preventDefault();

    // Simple validation
    if (!userName) {
      setUsernameError(true);
      setUsernameErrorMessage("Username is required");
      return;
    } else {
      setUsernameError(false);
      setUsernameErrorMessage("");
    }

    if (!pass) {
      setPasswordError(true);
      setPasswordErrorMessage("Password is required");
      return;
    } else {
      setPasswordError(false);
      setPasswordErrorMessage("");
    }

    const loginUrl = `${process.env.REACT_APP_SERVER_URL}/auth/login`;
    const formData = new FormData();
    formData.append("userName", userName);
    formData.append("password", pass);

    const loginResponse = await fetch(loginUrl, {
      method: 'POST',
      body: formData
    });

    const loginData = await loginResponse.json();

    if (loginData?.success) {
      login(loginData.data.token);
      
      setTimeout(() => {
        navigate('/admin');
      }, 0);
    } else {
      setUsernameError(true);
      setUsernameErrorMessage("Invalid username or password");
    }
  }

  return (
    <>
      <CssBaseline />
      <SignInContainer direction="column">

        <Card variant="outlined">
          <Typography
            component="h1"
            variant="h4"
            sx={{ width: '100%', fontSize: 'clamp(2rem, 10vw, 2.15rem)', fontWeight: "600" }}
          >
            Sign In
          </Typography>

          <Box
            component="form"
            noValidate
            onSubmit={loginUser}
            sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
          >
            <FormControl>
              <FormLabel htmlFor="username">Username</FormLabel>
              <TextField
                className="custom-input"
                error={usernameError}
                helperText={usernameErrorMessage}
                id="username"
                name="username"
                placeholder="your username"
                fullWidth
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
              />
            </FormControl>

            <FormControl>
              <FormLabel htmlFor="password">Password</FormLabel>
              <TextField
                className="custom-input"
                error={passwordError}
                helperText={passwordErrorMessage}
                id="password"
                type="password"
                placeholder="••••••"
                fullWidth
                value={pass}
                onChange={(e) => setPass(e.target.value)}
              />
            </FormControl>

            <FormControlLabel
              control={<Checkbox color="primary" />}
              label="Remember me"
            />

            <Button type="submit" fullWidth variant="contained" className="custom-login-btn">
              Sign In
            </Button>
          </Box>
        </Card>

      </SignInContainer>
    </>
  );
}
